module.exports = __webpack_public_path__ + "static/img/GoDaddy1.fc7469d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/GoDaddy1.gif
// module id = 1772
// module chunks = 5